import { useQuery } from '@apollo/client';
import { MarketingNegotiateIcon, NakedButton, SparkleGradientIcon, Theme } from '@spoiler-alert/ui-library';
import accounting from 'accounting';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { SuggestedNegotiationsQuery } from '../../graphql/queries';

const useStyles = createUseStyles({
  border: {
    border: '1px solid transparent',
    background: `linear-gradient(white, white) padding-box, ${Theme.iqGradient} border-box`,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    animation: '$iq-ripple 6s linear infinite, $slideInFromBottom 0.5s ease-out',
    backgroundSize: '200%',
    justifyContent: 'space-between',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    marginBottom: 24,
  },
  container: {
    background: 'linear-gradient(267deg, rgba(242, 218, 81, 0.05) 0.64%, rgba(42, 178, 74, 0.05) 43.67%, rgba(7, 190, 223, 0.05) 111.11%)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '8px 8px 8px 16px',
  },
  block: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  header: {
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '-0.176px',
  },
  buttonIcon: {
    backgroundColor: 'transparent',
    color: Theme.textColorPrimary,
    border: 'none',
    '& svg': {
      marginTop: 2,
      height: 20,
      width: 20,
    },
    '&:hover': {
      '& svg': {
        filter: 'invert(100%) brightness(1000%) contrast(100%)',
      },
    },
  },
  '@keyframes iq-ripple ': {
    '0%': {
      backgroundPosition: '0% 50%',
    },
    '50%': {
      backgroundPosition: '50% 100%',
    },
    '100%': {
      backgroundPosition: '0% 50%',
    },
  },
  '@keyframes slideInFromBottom': {
    '0%': {
      transform: 'translateY(50%)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateY(0)',
      opacity: 1,
    },
  },
});

const SuggestedNegotiationsVisibilityBanner = ({ history }) => {
  const classes = useStyles();
  const { data: suggestedNegotiationData } = useQuery(SuggestedNegotiationsQuery, {
    fetchPolicy: 'network-only',
  });
  const { totalNegotiationOpportunity, totalNegotiationSuggestions } = useMemo(() => {
    const negotiations = suggestedNegotiationData?.SuggestedNegotiationsQuery?.negotiations || [];
    let opportunity = 0;
    let suggestionsCount = 0;
    negotiations.forEach((negotiation) => {
      negotiation.offerListings.forEach((offer) => {
        opportunity += offer?.quantity * offer?.suggestions?.negotiation?.unitPrice - offer?.totalPrice || 0;
        suggestionsCount += 1;
      });
    });
    return {
      totalNegotiationOpportunity: opportunity,
      totalNegotiationSuggestions: suggestionsCount,
    };
  }, [suggestedNegotiationData]);
  return (
    totalNegotiationOpportunity > 0 && (
      <div className={classes.border}>
        <div className={classes.container}>
          <div className={classes.block}>
            <MarketingNegotiateIcon />
            <span className={classes.header}>
              Increase revenue by up to {accounting.formatMoney(Math.round(totalNegotiationOpportunity), { precision: 0 })} with suggested
              negotiations!
            </span>
          </div>
          <NakedButton iq icon={SparkleGradientIcon} className={classes.buttonIcon} onClick={() => history.push('/suggested-negotiations')}>
            View {totalNegotiationSuggestions} Suggested Negotiations
          </NakedButton>
        </div>
      </div>
    )
  );
};

SuggestedNegotiationsVisibilityBanner.propTypes = {
  history: PropTypes.object.isRequired,
};

export default SuggestedNegotiationsVisibilityBanner;
